import { SET_DETAILS_LICENSES, SET_DETAILS_ERROR_LICENSES } from '../types';

const initialState = {
  name: '',
  email: '',
  totalLicenses: 0,
  currentLicenses: 0,
  issuedLicensesCount: 0,
  totalLicensesCount: 0,
  connectedCount: 0,
  chasingCount: 0,
  currency: 'GBP',
  amount: 0,
  error: undefined,
  loading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DETAILS_LICENSES:
      return {
        totalLicenses: action.payload.totalLicenses,
        currentLicenses: action.payload.currentLicenses,
        issuedLicensesCount: action.payload.issuedLicensesCount,
        totalLicensesCount: action.payload.totalLicensesCount,
        connectedCount: action.payload.connectedCount,
        chasingCount: action.payload.chasingCount,
        amount: action.payload.amount,
        currency: action.payload.currency,
        email: action.payload.subscriber && action.payload.subscriber.emails[0].address,
        name: action.payload.name,
        loading: false,
      };
    case SET_DETAILS_ERROR_LICENSES:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};
